// src/components/Modals/XModal/CustomEmojiPicker.js

import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { emojiCategories, searchEmojis } from './emojiData';
import './CustomEmojiPicker.css';

const CustomEmojiPicker = ({ onEmojiClick, onClose }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [activeCategory, setActiveCategory] = useState('Yüzler ve İfadeler');
  const searchInputRef = useRef(null);
  
  // Mouse down olayını takip et
  const mouseDownInsidePicker = useRef(false);

  // Component yüklendiğinde search input'a focus
  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  // Arama işlemi
  useEffect(() => {
    if (searchTerm.trim()) {
      const results = searchEmojis(searchTerm);
      setSearchResults(results);
    } else {
      setSearchResults([]);
    }
  }, [searchTerm]);

  // Emoji tıklama
  const handleEmojiClick = (emoji) => {
    onEmojiClick({ emoji });
  };

  // Kategori değiştir
  const handleCategoryChange = (category) => {
    setActiveCategory(category);
    setSearchTerm(''); // Kategori değişince aramayı temizle
  };

  // Mouse down olayını yakala
  const handleMouseDown = (e) => {
    // Picker içinde mi dışında mı kontrol et
    if (e.target.closest('.custom-emoji-picker')) {
      mouseDownInsidePicker.current = true;
    } else {
      mouseDownInsidePicker.current = false;
    }
  };

  // Mouse up olayını yakala
  const handleMouseUp = (e) => {
    // Eğer tıklama picker içinde başlamadıysa ve overlay'de bitiyorsa kapat
    if (!mouseDownInsidePicker.current && !e.target.closest('.custom-emoji-picker')) {
      onClose();
    }
    // Reset
    mouseDownInsidePicker.current = false;
  };

  // Portal kullanarak body'ye render et
  const pickerContent = (
    <>
      {/* Overlay - Mouse olaylarını dinle */}
      <div 
        className="custom-emoji-overlay" 
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
      />

      {/* Picker Container */}
      <div className="custom-emoji-picker">
        {/* Close Button */}
        <button 
          className="custom-emoji-close" 
          onClick={onClose}
        >
          ✕
        </button>

        {/* Header with Search */}
        <div className="custom-emoji-header">
          <h3>Emoji Seç</h3>
          <div className="custom-emoji-search">
            <span className="search-icon">🔍</span>
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Emoji ara... (gülümseme, kalp, ateş, yıldız...)"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="custom-emoji-search-input"
            />
            {searchTerm && (
              <button 
                className="clear-search"
                onClick={() => setSearchTerm('')}
              >
                ✕
              </button>
            )}
          </div>
        </div>

        {/* Categories */}
        {!searchTerm && (
          <div className="custom-emoji-categories">
            {Object.keys(emojiCategories).map((category) => (
              <button
                key={category}
                className={`category-btn ${activeCategory === category ? 'active' : ''}`}
                onClick={() => handleCategoryChange(category)}
              >
                {category}
              </button>
            ))}
          </div>
        )}

        {/* Emoji Grid */}
        <div className="custom-emoji-grid">
          {searchTerm ? (
            // Arama Sonuçları
            searchResults.length > 0 ? (
              <>
                <div className="result-count">
                  {searchResults.length} emoji bulundu
                </div>
                {searchResults.map((emojiData, index) => (
                  <button
                    key={`${emojiData.emoji}-${index}`}
                    className="emoji-btn"
                    onClick={() => handleEmojiClick(emojiData.emoji)}
                    title={`${emojiData.name} - ${emojiData.tr}`}
                  >
                    {emojiData.emoji}
                  </button>
                ))}
              </>
            ) : (
              <div className="no-results">
                <div className="no-results-icon">😕</div>
                <div className="no-results-text">Emoji bulunamadı</div>
                <div className="no-results-hint">
                  Farklı bir kelime deneyin
                </div>
              </div>
            )
          ) : (
            // Kategori Emojileri
            emojiCategories[activeCategory]?.map((emojiData, index) => (
              <button
                key={`${emojiData.emoji}-${index}`}
                className="emoji-btn"
                onClick={() => handleEmojiClick(emojiData.emoji)}
                title={`${emojiData.name} - ${emojiData.tr}`}
              >
                {emojiData.emoji}
              </button>
            ))
          )}
        </div>
      </div>
    </>
  );

  // Portal kullanarak body'ye render et
  return ReactDOM.createPortal(
    pickerContent,
    document.body
  );
};

export default CustomEmojiPicker;